import * as React from "react";
import { connect } from "react-redux";
import PatientsOrder from "../../screens/Patients/PatientsOrder";

import {
  PatientOrder,
  PatientsOrderSlectedPage
} from "./action";
class PatientsOrderContainer extends React.Component<Props, State> {
  render() {
    return (
      <PatientsOrder
        PatientOrder={this.props.PatientOrder}
        patientorederDtlsList={this.props.patientorederDtlsList}
        patientorederDtlsCount={this.props.patientorederDtlsCount}
        PatientsOrderSlectedPage={this.props.PatientsOrderSlectedPage}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    PatientOrder: (value) => {
      dispatch(PatientOrder(value));
    },
    PatientsOrderSlectedPage: value => {
      dispatch(PatientsOrderSlectedPage(value));
    }
  }
};

const mapStateToProps = state => {
  return {
    patientorederDtlsList: state.PatientsOrderReducer.patientorederDtlsList,
    patientorederDtlsCount: state.PatientsOrderReducer.patientorederDtlsCount,
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(PatientsOrderContainer);
